'use client';

import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getLocalPendingHavaleState, clearPendingOrder, PENDING_ORDER_KEY } from '../utils/pendingHavaleOrder';

export default function PendingHavaleResumeModal() {
  const navigate = useNavigate();
  const location = useLocation();
  const [pending, setPending] = useState(null);

  useEffect(() => {
    if (location.pathname === '/siparis-basarili' || location.pathname === '/siparis-teyit') {
      return;
    }

    try {
      const raw = localStorage.getItem(PENDING_ORDER_KEY);
      if (!raw) return;

      const data = JSON.parse(raw);
      const { canContinue, shouldClear } = getLocalPendingHavaleState(data);

      if (shouldClear) {
        clearPendingOrder();
        return;
      }

      if (canContinue) {
        setPending(data);
      }
    } catch {
      /* ignore */
    }
  }, [location.pathname]);

  if (!pending) return null;

  const shortId = String(pending.orderId).slice(0, 8).toUpperCase();

  const handleContinue = () => {
    setPending(null);
    navigate('/siparis-basarili');
  };

  const handleDismiss = () => {
    setPending(null);
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl">
        <h2 className="text-xl font-['Playfair_Display'] text-[#1a1a1a] mb-2">
          Bekleyen Havale Siparişiniz Var
        </h2>
        <p className="text-sm text-gray-600 mb-6 leading-relaxed">
          <strong>#{shortId}</strong> numaralı siparişiniz için havale/EFT ödemesi bekleniyor.
          Ödeme ve dekont, <strong>Carmen Kuyumculuk</strong> onayından sonra işleme alınır.
          Dekont yükleme sayfasına dönmek ister misiniz?
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            type="button"
            onClick={handleContinue}
            className="flex-1 rounded-xl bg-[#1a1a1a] px-4 py-3 text-sm font-medium text-white hover:bg-[#D4AF37] transition-colors"
          >
            Evet, Havaleye Devam Et
          </button>
          <button
            type="button"
            onClick={handleDismiss}
            className="flex-1 rounded-xl border border-gray-200 px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Şimdi Değil
          </button>
        </div>
      </div>
    </div>
  );
}
